export enum OfferType {
  AllDeals = 'All Deals',
  ExpiringSoon = 'Expiring Soon',
  ExpiringSoonMso = 'Expiring\nIn < 2 Weeks',
  CampaignViews = 'Campaign Views',
  CampaignViewsMso = 'Campaign\nViews',
  LastUpdated = 'Last Updated\n> 60 Days Ago',
  NinetyDaysOnLeaseContract = '90 Days on\nLease Contracts',
  Pagination = 'Pagination',
}
